import { render, staticRenderFns } from "./OrdersAnalytics.vue?vue&type=template&id=581a9430&"
import script from "./OrdersAnalytics.vue?vue&type=script&lang=js&"
export * from "./OrdersAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports